import React, { useEffect, useState } from 'react'
import ClientManagementLayout from '../ClientManagementLayout'
import { GetAccess, GetNotUseRole, GetUseRole } from '../../../../Components/Utils/roles';
import { useLocation, useParams } from 'react-router-dom';
import CustomDataTable from '../../../../Components/Others/CustomDataTable';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import { useFormik } from 'formik';
import * as yup from 'yup';
import MobileClientIndex from '../../../Mobile/ClientManage/ClientMoblie/MobileClientIndex';
import MultiEditClient from './MultiEditClient';
import ImportClient from './ImportClient';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { NuDate } from '../../../../Components/Utils/Input';
import axiosInstance from '../../../../Services/axiosCommon';
import CloseIcon from '../../../../Components/Icons/Close';
import Pagination from '../../../../Components/Utils/Pagenation';
import ClientCard from './ClientCard';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import NuDateFormate, { formatDate }  from '../../../../Components/Utils/NuDate';
import UseGetDataSearchlist from '../../../../Components/Hooks/useFetchDataByListing';
import ImportFileModal from '../../../../Components/Utils/ImportFileComponent';


function ClientIndex() {

  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const { officeId } = useParams();
  const [showExport, setShowExport] = useState(false);

  const { value: status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "statusClient", [showFilterDialog, showExport],
    () => showFilterDialog || showExport
  ); 
 
   const [screenSize, setScreenSize] = useState({
          width: window.innerWidth,
        });
      
        useEffect(() => {
          const handleResize = () => {
            setScreenSize({
              width: window.innerWidth,
            });
          };
      
          window.addEventListener("resize", handleResize);
      
          return () => {
            window.removeEventListener("resize", handleResize);
          };
        }, []);

  const location = useLocation();
  const currentPage= location.state?.currentPage
  const searchQuery= location.state?.searchQuery
  const [page, setPage] = useState(currentPage||1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
  const state = location.state;
  const [filter, setFilter] = useState(
    state?.status || state?.category ? true : false
  );
   
    const [filterProps, setFilterProps] = useState({
  
      status:"",
      
    });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search:searchQuery||"",

    status:state?.status? state.status :"",
     });

  const clearFilter = ()=> {
    setParams({...params,status:"",})
    formik.values.status=""
  


      setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
   onSubmit: async (value, { resetForm }) => {
  await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting
  setParams({...params,status:value.status});
  closeFilterDialog();
  setFilter(true);
  setFilterProps({ status:"" });
}
  })
 const [viewMode, setViewMode] = useState(
    localStorage.getItem("viewMode") || "card"
  );
//   const { data, total, getData, dataLoading } = UseGetDataSearch(
//   `/clients/list`,
//   params,
//   'clients'
// );
const { data, total, getData, dataLoading, active, inactive } = UseGetDataSearch(
  `/clients/list`,
  params,
  
);

// const total = data.length;

  

  const defaultHeader = [
    // {
    //   title: "Ref.",
    //   width: "5%",
    //   isLink: true,
    //   id: "clientId",
    //   link: `/client-management/clients/view/`,
    
    //   field: "refNumber",
    //   textAlign: "left",
    //   rowAlign: "left",
    // },
    // (GetNotUseRole("client")  &&
    {
      title: "Company",
      width: "18%",
      isLink: true,
      id: "clientId",
      link: `/client-management/clients/view/`,
      field: "companyName",
      textAlign: "left",
      rowAlign: "left",
    },
  // ),
    {
      title: "Contact Person",
      width: "18%",
      isLink: true,
      id: "clientId",
      link: `/client-management/clients/view/`,
      field: "contactPerson",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Designation",
      width: "18%",
      field: "designation",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Phone",
      width: "18%",
      field: "phone",
      textAlign: "left",
      rowAlign: "left",
    },
    
    // {
    //   title: "Email",
    //   width: "15%",
    //   field: "email",
    //   textAlign: "left",
    //   rowAlign: "left",
    // },

    {
      title: "Status",
      width: "18%",
      field: "status",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Action",
      width: "10%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents:{
        // fetcher:getData,
        id:"clientId",
        removeValue:"companyName",
        url:`/clients/`,
        moduleName:"Client",
        from:`/client-management/clients`,
        editLink:`/client-management/clients/edit/`,
        viewLink:`/client-management/clients/view/`

      }
    },
  ];
  const availableHeaders = [
   
  ];

  useEffect(() => {
      localStorage.setItem("viewMode", viewMode);
      setParams({ ...params, page: page, per_page: pageCount });
    }, [page, pageCount, viewMode]);
  
  
  
  

  const [exportValue, setExportValue] = useState({
    status:""
  });
  const ExportFormik = useFormik({
  enableReinitialize: true,
  initialValues: exportValue,
  validateOnChange: false,
  validateOnBlur: false,
  onSubmit: async (value, { resetForm }) => {
    try {
      // 🔥 keep Formik in "submitting" mode until this finishes
      const response = await axiosInstance.get(
        `/clients/export?status=${value.status}`,
        { responseType: "blob" }
      );

      const pdfBlob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `Client Report ${formatDate(new Date())}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  }
});

  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const selectOneFunction = (value) =>{ 
    let NewId;
    if(listofNumbers && listofNumbers.some(Item=>Item ===value)){
      NewId = listofNumbers.filter(Temp=> Temp !== value);
      setListofNumbers(NewId)
    }else{
      setListofNumbers([...listofNumbers,value])
    }
  }

  const selectMultipleFunction = (e) =>{ 

    if(e.target.checked){
      setListofNumbers(fullList)
    }else{
      setListofNumbers([])
    }
    

      }

      useEffect(()=>{
        setParams({...params,page:page,per_page:pageCount})
       },[page,pageCount])
    

      const closeFilterDialog = () => {
        setShowFilterDialog(false);
      };
  const [showImportModal, setShowImportModal] = useState(false);


  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };

  useEffect(()=>{
    let tempArr = []
    data && data.forEach(i=>{
     
      tempArr.push(i?.clientId)
    });
    setFullList(tempArr)
  },[data])

  const [valueOfSearch,setValuesofSearch] = useState("")
   function searchFunction(e) {
 
     
     setValuesofSearch(e?.target?.value)
     setParams({ ...params, search: e?.target?.value, page:1 });
     setPage(1)
   }

   // Define your actual API delete function for a single schedule
  const deleteSchedule = async (clientId) => {
    const response = await axiosInstance.delete(`/clients/${clientId}`);
    return response; // Return the entire Axios response
  };



  return (
    <>
    <ClientManagementLayout 
      setOpen={setShowImportModal}
      searchFun={searchFunction}
      searchValue={valueOfSearch}

      getData={getData}
      isFilter={filter}
      neededSearch={true}
      newfilter={true}
  officeId={officeId}

      setFilterOpen={setShowFilterDialog}
      ClearFilter={clearFilter}
      CreateAccess={GetAccess("clients_create")}
      ImportAccess={GetAccess("clients_import")}
      ExportAccess={GetAccess("client_export")}
      setViewMode={setViewMode}
        viewMode={viewMode}
      setOpenExport={setShowExport}
 isCard={true}

      total={total}
      active = { active }
  inactive = { inactive }
      // officeId={officeId}
      // projectID={projectID}
        >


         
{
  screenSize.width <= "786" ?(<>
  <div className=' w-full h-[calc(100vh-205px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
  <MobileClientIndex
  data={data}
  total={total}
  active = { active }
  inactive = { inactive }
  pageIndex={page}
  setPageIndex={setPage}
  dataCount={pageCount}
  setDataCount={setPageCount}
  officeId={officeId}
  getData={getData}

  />
  </div>
  </>):(<>


    <div className='w-full h-full  '>
      {/* <div className='w-full flex justify-between items-center'>
        <Breadcrumb
          items={[
            { name: "Procurement" },
            { name: "YPR" },
          ]} />
        <div className=' flex gap-2'>
        <SearchBar
              handleChange={(e) =>{
                setParams({ ...params, search: e.target.value, page:1 });
                setPage(1)
              }}
              value={params.search||searchQuery}
            />  <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
          {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>} */}
        
          {/* {GetAccess("purchase_request_create") && <ImportButton handleClick={handleImportClick} />} */}
          {/* {GetAccess("purchase_request_create") && <Link to={`/main/${officeId}/procurement/purchase-requests/create`}><CreateButton label='YPR' /></Link>}
        </div>
      </div> */}
  {viewMode === "list" ? (

      <CustomDataTable 
      fetcher={getData}
        data={data} 
        availableHeaders={availableHeaders} 
        defaultHeader={defaultHeader}
        bodyHeight='max-h-[calc(100vh-260px)]'
        height='h-[calc(100vh-160px)]'
        total={total}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        title='Clients'
        storageName="ClientTable"
        selectOneFunction={selectOneFunction}
        setShowDelete={setShowDelete}
        showDelete={showDelete}
        setShowEdit={setShowEdit}
        showEdit={showEdit}
        listofNumbers={listofNumbers}
        hasMultiEdit={true}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        getById="clientId"
        editAccess="clients_edit"      
        deteleAccess="clients_delete" 
        dataLoading={dataLoading}
        searchQuery={params?.search!=""?params?.search:""}
        // dateShow={true}
        hasMultiDelete={true}
                identifierKey="companyName"
                deleteSingleItem={deleteSchedule}
        />

      ) : (
        <>
        <div className='w-full h-[calc(100vh-210px)] lg:h-[calc(100vh-190px)] rounded-md bg-white p-3 mt-0.5 relative overflow-y-scroll'>
       {/* <div className='flex gap-40'> */}
      
        {/* <p className='text-xs font-semibold text-[#111537] text-left'>Client : {total}</p> */}
        {/* <p className='text-sm'>Credit : {}</p>
         <p className='text-sm'>Advance : {}</p>
         */}

       
        {/* </div> */}
          <div className='w-full flex justify-start flex-wrap md:gap-x-5 lg:gap-x-6 gap-y-6 pt-4'>
            
            {data && data.map((item, idx) => (
              <ClientCard fetcher={getData}  item={item} key={idx} />
            ))}
          </div>
        </div>
        <div className="w-full h-[40px] rounded-b-md bg-white">
          <Pagination
            total={total}
            pageIndex={page}
            setPageIndex={setPage}
            dataCount={pageCount}
            setDataCount={setPageCount}
          />
        </div>
        </>
      )}
    </div>

</>)}

  

        </ClientManagementLayout>

        {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col mb-4">
              <FormikSelectTwo
                            label="Status"
                            placeholder="Choose"
                            Options={status}
                            formik={formik}
                            name="status"
                            width="w-full "
                          
              
                          />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" isLoading={formik.isSubmitting} />

              </div>
            </form>
          </div>
        </div>
      )}

      {showEdit && (
        <MultiEditClient
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )}
      {showImportModal && (
        <ImportFileModal
          show={showImportModal}
          onClose={closeModal}
        apiUrl="/clients/import"
        menuName="Client"
        getData={getData}
        />
        
      )}

{showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[85%]  sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type =="all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                    <FormikSelectTwo
                            label="Status"
                            placeholder="Choose"
                            Options={status}
                            formik={ExportFormik}
                            name="status"
                            width="w-full"
                          
              
                          />

                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton name="Export" isLoading={ExportFormik.isSubmitting} />

                </div>
              </div>
            </form>
          </div>
        </div>
      )}


        
    </>
  )
}

export default ClientIndex
